import { render, staticRenderFns } from "./ProductGroupedOptionField.vue?vue&type=template&id=3a47c7d2&"
import script from "./ProductGroupedOptionField.vue?vue&type=script&lang=js&"
export * from "./ProductGroupedOptionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports